/* ===========================================================================
 * Maison Broderie — Page Salons & Événements
 *
 * Pour ajouter / retirer un salon : éditer le tableau SALONS ci-dessous.
 * Chaque entrée :
 *   id            identifiant unique (slug, sans accents ni espaces)
 *   name          nom du salon en CAPS, avec "i" minuscule à l'intérieur
 *                 si vous voulez respecter la signature typo MB
 *   organizer     organisateur (texte lisible)
 *   organizerUrl  lien officiel du salon
 *   dateStart     ISO YYYY-MM-DD
 *   dateEnd       ISO YYYY-MM-DD (= dateStart si une journée)
 *   city          ville affichée
 *   venue         lieu (stade, parc expo, hall…)
 *   address       adresse complète pour Google Maps
 *   coords        { x, y } position sur la carte SVG (viewBox 0 0 1000 994)
 *                 projetée depuis la lat/lon réelle via .impeccable/geo/gen.mjs
 *   note          (optionnel) info pratique courte affichée en italique
 * =========================================================================== */

const SALONS = [
  {
    id: 'otp-lyon-2026',
    name: 'JOURNÉES OTP · LYON',
    organizer: 'Les Journées OTP',
    organizerUrl: 'https://www.eventsotp.com/agenda/',
    dateStart: '2026-09-15',
    dateEnd:   '2026-09-15',
    city: 'Lyon',
    venue: 'Groupama Stadium',
    address: '10 Av. Simone Veil, 69150 Décines-Charpieu',
    coords: { x: 648, y: 570 }
  },
  {
    id: 'otp-aix-marseille-2026',
    name: 'JOURNÉES OTP · AiX-MARSEiLLE',
    organizer: 'Les Journées OTP',
    organizerUrl: 'https://www.eventsotp.com/agenda/',
    dateStart: '2026-09-08',
    dateEnd:   '2026-09-08',
    city: 'Aix-en-Provence',
    venue: 'Pasino Aix-en-Provence',
    address: "21 Av. de l'Europe, 13090 Aix-en-Provence",
    coords: { x: 686, y: 786 }
  },
  {
    id: 'otp-rennes-2026',
    name: 'JOURNÉES OTP · RENNES',
    organizer: 'Les Journées OTP',
    organizerUrl: 'https://www.eventsotp.com/agenda/',
    dateStart: '2026-09-22',
    dateEnd:   '2026-09-22',
    city: 'Rennes',
    venue: 'Glaz Arena',
    address: 'Chemin du Bois de la Justice, 35510 Cesson-Sévigné',
    coords: { x: 215, y: 334 }
  },
  {
    id: 'otp-lens-2026',
    name: 'JOURNÉES OTP · LENS',
    organizer: 'Les Journées OTP',
    organizerUrl: 'https://www.eventsotp.com/agenda/',
    dateStart: '2026-09-29',
    dateEnd:   '2026-09-29',
    city: 'Lens',
    venue: 'Stade Bollaert-Delelis',
    address: 'Av. Alfred Maes, 62300 Lens',
    coords: { x: 503, y: 118 }
  },
  {
    id: 'sign2com-courtrai-2026',
    name: 'SiGN2COM · COURTRAi',
    organizer: 'Sign2Com / Kortrijk Xpo',
    organizerUrl: 'https://www.sign2com.com/fr/home/',
    dateStart: '2026-10-04',
    dateEnd:   '2026-10-06',
    city: 'Courtrai',
    venue: 'Kortrijk Xpo',
    address: 'Doorniksesteenweg 216, 8500 Kortrijk, Belgique',
    coords: { x: 540, y: 66 },
    labelOffset: { dx: 90, dy: 0 }, // pin proche de Courtrai ; libellé décalé à droite pour dégager le pin de Lens
    country: 'BE',
    note: 'Salon de la signalétique et de la communication visuelle'
  },
  {
    id: 'otp-bordeaux-2026',
    name: 'JOURNÉES OTP · BORDEAUX',
    organizer: 'Les Journées OTP',
    organizerUrl: 'https://www.eventsotp.com/agenda/',
    dateStart: '2026-10-06',
    dateEnd:   '2026-10-06',
    city: 'Bordeaux',
    venue: 'Stade Atlantique · Bordeaux Métropole',
    address: 'Cr Jules Ladoumegue, 33300 Bordeaux',
    coords: { x: 267, y: 656 }
  },
  {
    id: 'otp-metz-2026',
    name: 'JOURNÉES OTP · METZ',
    organizer: 'Les Journées OTP',
    organizerUrl: 'https://www.eventsotp.com/agenda/',
    dateStart: '2026-10-13',
    dateEnd:   '2026-10-13',
    city: 'Metz',
    venue: 'Stade Saint-Symphorien',
    address: '8 Rue du Stade, 57050 Longeville-lès-Metz',
    coords: { x: 713, y: 243 }
  },
  {
    id: 'aiguille-en-fete-2026',
    name: 'CRÉATiON & SAVOiR-FAiRE · AiGUiLLE EN FÊTE',
    organizer: 'Création & Savoir-Faire',
    organizerUrl: 'https://www.creations-savoir-faire.com/fr-FR/aiguille-en-fete',
    dateStart: '2026-11-18',
    dateEnd:   '2026-11-22',
    city: 'Paris',
    venue: 'Paris Expo Porte de Versailles',
    address: '1 Place de la Porte de Versailles, 75015 Paris',
    coords: { x: 468, y: 274 },
    note: 'Dates à confirmer auprès de l\'organisateur'
  },
  {
    id: 'cprint-lyon-2027',
    name: 'C!PRiNT LYON 2027',
    organizer: 'Salon C!Print',
    organizerUrl: 'https://www.salon-cprint.com/fr/',
    dateStart: '2027-02-02',
    dateEnd:   '2027-02-04',
    city: 'Lyon',
    venue: 'Eurexpo',
    address: 'Eurexpo Lyon, Boulevard de l\'Europe, 69680 Chassieu',
    coords: { x: 645, y: 574 }
  }
];

/* ===========================================================================
 * UTILITAIRES — formatage de date FR + .ics + maps
 * =========================================================================== */

const MONTHS_FR = ['JAN', 'FÉV', 'MAR', 'AVR', 'MAi', 'JUiN', 'JUiL', 'AOÛT', 'SEPT', 'OCT', 'NOV', 'DÉC'];
const WEEKDAYS_FR = ['DiM.', 'LUN.', 'MAR.', 'MER.', 'JEU.', 'VEN.', 'SAM.'];
const MONTHS_FR_LONG = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

function parseDate(iso) {
  // Tolère une entrée manquante ou mal formée (le tableau SALONS est édité à la
  // main) : on renvoie une date invalide plutôt que de lever une exception.
  if (typeof iso !== 'string') return new Date(NaN);
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return new Date(NaN);
  return new Date(y, m - 1, d);
}

function fmtRangeDay(start, end) {
  // "08" ou "18 — 22"
  const s = parseDate(start);
  const e = parseDate(end);
  if (s.getTime() === e.getTime()) {
    return String(s.getDate()).padStart(2, '0');
  }
  return String(s.getDate()).padStart(2, '0') + ' – ' + String(e.getDate()).padStart(2, '0');
}

function fmtMonthYear(start, end) {
  // "SEPT 2026" — ou si à cheval sur 2 mois "NOV — DÉC 2026"
  const s = parseDate(start);
  const e = parseDate(end);
  const sMonth = MONTHS_FR[s.getMonth()];
  const eMonth = MONTHS_FR[e.getMonth()];
  if (sMonth === eMonth) {
    return sMonth + ' ' + s.getFullYear();
  }
  return sMonth + ' – ' + eMonth + ' ' + e.getFullYear();
}

function icsDate(iso) {
  return iso.replace(/-/g, '');
}

function downloadICS(salon) {
  // DTEND est exclusif pour les events all-day
  const endDate = parseDate(salon.dateEnd);
  endDate.setDate(endDate.getDate() + 1);
  const dtEnd = endDate.getFullYear() +
                String(endDate.getMonth() + 1).padStart(2, '0') +
                String(endDate.getDate()).padStart(2, '0');

  const dtStamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

  const summary = salon.name + ' · Maison Broderie';
  const description = 'Retrouvez Maison Broderie sur ' + salon.organizer + ' à ' + salon.city + '. Plus d\'infos : ' + salon.organizerUrl;
  const location = salon.venue + ', ' + salon.address;

  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Maison Broderie//Salons//FR',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    'UID:' + salon.id + '@maisonbroderie.com',
    'DTSTAMP:' + dtStamp,
    'DTSTART;VALUE=DATE:' + icsDate(salon.dateStart),
    'DTEND;VALUE=DATE:' + dtEnd,
    'SUMMARY:' + escapeICS(summary),
    'DESCRIPTION:' + escapeICS(description),
    'LOCATION:' + escapeICS(location),
    'URL:' + salon.organizerUrl,
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'maison-broderie-' + salon.id + '.ics';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function escapeICS(str) {
  return String(str).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
}

function mapsUrl(salon) {
  return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(salon.venue + ', ' + salon.address);
}

/* ===========================================================================
 * SVG — icônes
 * =========================================================================== */

const ICON_CALENDAR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="8" y1="3" x2="8" y2="7"/><line x1="16" y1="3" x2="16" y2="7"/><circle cx="12" cy="15" r="1.4" fill="currentColor"/></svg>';
const ICON_MAP_PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s-7-7.58-7-13a7 7 0 0 1 14 0c0 5.42-7 13-7 13z"/><circle cx="12" cy="9" r="2.5"/></svg>';
const ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
const ICON_EXTERNAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';

/* Drapeaux nationaux — SVG inline (3 bandes), fiables sur tous les OS contrairement
   aux emojis drapeaux (non rendus sous Windows). Choisi via salon.country ('BE' = Belgique,
   tout le reste = France par défaut). Décoratif (aria-hidden) : le pays figure déjà dans
   l'adresse et le JSON-LD. */
const FLAG_FR = '<svg class="salon-flag" viewBox="0 0 3 2" aria-hidden="true" focusable="false"><rect width="1" height="2" x="0" fill="#002654"/><rect width="1" height="2" x="1" fill="#ffffff"/><rect width="1" height="2" x="2" fill="#ED2939"/></svg>';
const FLAG_BE = '<svg class="salon-flag" viewBox="0 0 3 2" aria-hidden="true" focusable="false"><rect width="1" height="2" x="0" fill="#2D2A26"/><rect width="1" height="2" x="1" fill="#FAE042"/><rect width="1" height="2" x="2" fill="#ED2939"/></svg>';
function flagFor(salon) { return (salon && salon.country === 'BE') ? FLAG_BE : FLAG_FR; }

/* ===========================================================================
 * RENDU
 * =========================================================================== */

function getUpcomingSalons() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return SALONS
    .filter(s => {
      const end = parseDate(s.dateEnd);
      if (isNaN(end)) {
        console.warn('[salons] date invalide pour « ' + (s && s.id) + ' » — entrée ignorée.');
        return false;
      }
      return end >= today;
    })
    .sort((a, b) => parseDate(a.dateStart) - parseDate(b.dateStart));
}

function renderAgenda(upcoming) {
  const host = document.querySelector('[data-agenda-list]');
  if (!host) return;

  if (upcoming.length === 0) {
    host.innerHTML = `
      <li class="agenda-empty">
        <h3 class="agenda-empty-title">PROCHAiNES DATES EN PRÉPARATiON</h3>
        <p class="agenda-empty-body">Le calendrier de la prochaine saison est en cours de finalisation. En attendant, on peut se voir autrement.</p>
        <div class="agenda-fallback-actions agenda-empty-actions">
          <a href="#repli" class="btn btn-secondary">Voir les showrooms &amp; la démo à distance</a>
          <a href="#alerte" class="agenda-fallback-link">M'alerter dès qu'une date ouvre →</a>
        </div>
      </li>`;
    return;
  }

  host.innerHTML = upcoming.map((salon, idx) => {
    const isNext = idx === 0;
    // Jour de la semaine : seulement pour un événement d'une journée (sur une
    // plage de dates, le jour seul induirait en erreur). Aide à planifier la venue.
    const isSingleDay = salon.dateStart === salon.dateEnd;
    const weekday = isSingleDay ? WEEKDAYS_FR[parseDate(salon.dateStart).getDay()] : '';
    return `
      <li class="agenda-row ${isNext ? 'is-next' : ''}" id="evt-${salon.id}" data-event-id="${salon.id}">
        <div class="agenda-date">
          ${weekday ? `<span class="agenda-date-weekday">${weekday}</span>` : ''}
          <span class="agenda-date-day">${fmtRangeDay(salon.dateStart, salon.dateEnd)}</span>
          <span class="agenda-date-month">${fmtMonthYear(salon.dateStart, salon.dateEnd)}</span>
        </div>
        <div class="agenda-info">
          ${isNext ? '<span class="agenda-tag-next">PROCHAiNE DATE</span>' : ''}
          <h3 class="agenda-name">${salon.name}</h3>
          <span class="agenda-city">
            <span class="agenda-city-name">${flagFor(salon)}${escapeHtml(salon.city)}</span>
            <span class="agenda-sep">·</span>
            <span>${escapeHtml(salon.venue)}</span>
          </span>
          <span class="agenda-venue">${escapeHtml(salon.address)}</span>
          ${salon.note ? `<span class="agenda-note">${escapeHtml(salon.note)}</span>` : ''}
          <span class="agenda-organizer">
            <a href="${salon.organizerUrl}" target="_blank" rel="noopener noreferrer">${escapeHtml(salon.organizer)} ↗</a>
          </span>
        </div>
        <div class="agenda-actions">
          <button type="button" class="agenda-action" data-ics="${salon.id}" aria-label="Ajouter ${escapeHtml(salon.name)} à mon calendrier">
            ${ICON_CALENDAR}
            <span class="agenda-action-label">CALENDRiER</span>
          </button>
          <a href="${mapsUrl(salon)}" target="_blank" rel="noopener noreferrer" class="agenda-action" aria-label="Itinéraire vers ${escapeHtml(salon.venue)}">
            ${ICON_MAP_PIN}
            <span class="agenda-action-label">iTiNÉRAiRE</span>
          </a>
        </div>
      </li>`;
  }).join('');
}

function injectFrancePath() {
  // Le tracé est exposé par france-path.js comme window.__FRANCE_PATH__
  const path = window.__FRANCE_PATH__;
  if (!path) return;
  const clip = document.getElementById('frClipPath');
  const outline = document.getElementById('frOutline');
  if (clip) clip.setAttribute('d', path);
  if (outline) outline.setAttribute('d', path);
}

function injectBelgiumPath() {
  const path = window.__BELGIUM_PATH__;
  if (!path) return;
  const clip = document.getElementById('beClipPath');
  const outline = document.getElementById('beOutline');
  // Hachure : silhouette complète de la Belgique.
  if (clip) clip.setAttribute('d', path);
  // Contour : uniquement le bord non partagé (la frontière FR/BE est tracée par la France
  // → une seule ligne, pas de double trait plus épais/foncé).
  if (outline) outline.setAttribute('d', window.__BELGIUM_OUTLINE__ || path);
}

function renderMapPins(upcoming) {
  const host = document.querySelector('.france-pins');
  if (!host) return;

  // On dédoublonne par ville pour ne pas empiler deux pins au même endroit ;
  // une entrée sans coordonnées valides est ignorée (la liste agenda, elle,
  // continue de l'afficher) plutôt que de faire planter tout le rendu carte.
  const seen = new Set();
  const pins = upcoming.filter(s => {
    if (!s.coords || !Number.isFinite(s.coords.x) || !Number.isFinite(s.coords.y)) {
      console.warn('[salons] coordonnées carte manquantes pour « ' + s.id + ' » — pin ignoré.');
      return false;
    }
    const key = (s.city || '').toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  const nextId = upcoming[0]?.id;

  host.innerHTML = pins.map(salon => {
    const isNext = salon.id === nextId;
    const dateLabel = fmtPinDate(salon.dateStart, salon.dateEnd);
    // Teardrop pin path : tip at (0,0), bulb 28 SVG units above
    const pinPath = 'M0 0 c-7,-11 -14,-18 -14,-28 a14 14 0 1 1 28 0 c0 10 -7 17 -14 28 z';
    const linkTitle = salon.name + ' · ' + salon.city + ' · ' + dateLabel;
    // Libellé décalé (villes voisines) : on garde le pin sur la ville et on déporte la carte,
    // reliée par un fin trait, pour ne pas masquer un pin voisin.
    const off = salon.labelOffset || { dx: 0, dy: 0 };
    const leader = (off.dx || off.dy)
      ? `<line class="pin-leader" x1="0" y1="-4" x2="${off.dx}" y2="${off.dy + 12}" />`
      : '';
    // tabindex=-1 : la carte est décorative (conteneur aria-hidden) ; les pins
    // restent cliquables à la souris mais sortent du parcours clavier / lecteur
    // d'écran — la liste agenda en dessous est l'équivalent accessible (WCAG 4.1.2).
    return `
      <a class="france-pin-link" href="#evt-${salon.id}" data-scroll-to="evt-${salon.id}" tabindex="-1" aria-hidden="true">
        <title>${escapeHtml(linkTitle)}</title>
        <g class="france-pin ${isNext ? 'is-next' : ''}" transform="translate(${salon.coords.x},${salon.coords.y})">
          <ellipse class="pin-shadow" cx="0" cy="2" rx="8" ry="2.2" />
          ${leader}
          <path class="pin-drop" d="${pinPath}" />
          <circle class="pin-dot" cx="0" cy="-30" r="4.5" />
          <foreignObject x="${-110 + off.dx}" y="${8 + off.dy}" width="220" height="80" class="pin-fo">
            <div xmlns="http://www.w3.org/1999/xhtml" class="france-pin-card">
              <span class="france-pin-city">${escapeHtml(salon.city)}</span>
              <span class="france-pin-date">${dateLabel}</span>
            </div>
          </foreignObject>
        </g>
      </a>`;
  }).join('');
}

// Format compact pour le label de pin : "8 septembre", "18 — 22 nov."
function fmtPinDate(start, end) {
  const s = parseDate(start);
  const e = parseDate(end);
  if (s.getTime() === e.getTime()) {
    return s.getDate() + ' ' + MONTHS_FR_LONG[s.getMonth()];
  }
  if (s.getMonth() === e.getMonth()) {
    return s.getDate() + '–' + e.getDate() + ' ' + MONTHS_FR_LONG[s.getMonth()];
  }
  return s.getDate() + ' ' + MONTHS_FR_LONG[s.getMonth()].slice(0,4) + '. – ' + e.getDate() + ' ' + MONTHS_FR_LONG[e.getMonth()].slice(0,4) + '.';
}

function renderJsonLd(upcoming) {
  // Schema.org Event[] — pour l'indexation Google des événements
  const items = upcoming.map(salon => ({
    '@context': 'https://schema.org',
    '@type': 'Event',
    'name': salon.name + ' · Maison Broderie',
    'startDate': salon.dateStart,
    'endDate':   salon.dateEnd,
    'eventAttendanceMode': 'https://schema.org/OfflineEventAttendanceMode',
    'eventStatus': 'https://schema.org/EventScheduled',
    'location': {
      '@type': 'Place',
      'name': salon.venue,
      'address': {
        '@type': 'PostalAddress',
        'streetAddress': salon.address,
        'addressLocality': salon.city,
        'addressCountry': salon.country || 'FR'
      }
    },
    'organizer': {
      '@type': 'Organization',
      'name': salon.organizer,
      'url': salon.organizerUrl
    },
    'performer': {
      '@type': 'Organization',
      'name': 'Maison Broderie',
      'url': 'https://www.maisonbroderie.com'
    },
    'url': salon.organizerUrl
  }));

  // Schema.org accepte un tableau de @graph
  const ld = {
    '@context': 'https://schema.org',
    '@graph': items
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(ld);
  document.head.appendChild(script);
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/* ===========================================================================
 * INTERACTIONS
 * =========================================================================== */

/* Confirmation : toast accessible + accusé de réception au point d'action.
   Les clics « Ajouter au calendrier » et « Itinéraire » sont l'objectif de
   conversion de la page ; ils doivent être confirmés à l'écran. */
let __toastTimer = null;
function showToast(kind, title, sub) {
  let toast = document.querySelector('.mb-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'mb-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }
  const icon = kind === 'maps' ? ICON_EXTERNAL : ICON_CHECK;
  toast.innerHTML =
    '<span class="mb-toast__icon mb-toast__icon--' + kind + '">' + icon + '</span>' +
    '<span class="mb-toast__msg"><strong>' + escapeHtml(title) + '</strong>' +
    (sub ? '<span class="mb-toast__sub">' + escapeHtml(sub) + '</span>' : '') + '</span>';
  void toast.offsetWidth; // reflow → la transition d'apparition se déclenche
  toast.classList.add('is-visible');
  clearTimeout(__toastTimer);
  __toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
}

function confirmAction(btn) {
  if (!btn) return;
  btn.classList.remove('is-confirmed');
  void btn.offsetWidth;
  btn.classList.add('is-confirmed');
  window.setTimeout(() => btn.classList.remove('is-confirmed'), 1800);
}

function bindIcsButtons() {
  document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-ics]');
    if (!target) return;
    e.preventDefault();
    const id = target.getAttribute('data-ics');
    const salon = SALONS.find(s => s.id === id);
    if (!salon) return;
    downloadICS(salon);
    confirmAction(target.closest('.agenda-action') || target);
    showToast('check', 'Ajouté à votre calendrier', salon.name);
  });
}

function bindItineraireToast() {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a.agenda-action');
    if (!link) return; // le lien s'ouvre normalement (nouvel onglet)
    showToast('maps', 'Itinéraire ouvert', 'dans un nouvel onglet');
  });
}

/* Capture email — alerte de salon + newsletter footer.
   Validation défensive (la validation native peut être contournée ou laxiste :
   « a@b » la passe), garde anti double-soumission, message d'erreur accessible
   conservant la saisie, accusé de succès. Le POST réseau reste à brancher
   (Shopify Customer Account / Klaviyo / Mailchimp) — voir le bloc « Stub ». */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

function bindEmailForms() {
  document.querySelectorAll('[data-email-capture]').forEach(setupEmailForm);
}

function setupEmailForm(form) {
  const input = form.querySelector('input[type="email"], input[name="email"]');
  const button = form.querySelector('button[type="submit"], button:not([type])');
  if (!input || !button) return;

  // Zone d'erreur accessible, annoncée par le lecteur d'écran et reliée au champ.
  const errId = 'email-err-' + Math.random().toString(36).slice(2, 8);
  const error = document.createElement('p');
  error.className = 'form-error';
  error.id = errId;
  error.hidden = true;
  error.setAttribute('role', 'alert');
  form.insertAdjacentElement('afterend', error);

  function clearError() {
    if (input.getAttribute('aria-invalid') !== 'true') return;
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
    error.hidden = true;
    error.textContent = '';
  }
  function showError(msg) {
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', errId);
    error.textContent = msg;
    error.hidden = false;
    input.focus();
  }

  input.addEventListener('input', clearError);

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (form.dataset.submitting === '1') return; // anti double-soumission

    const email = input.value.trim();
    if (email === '') { showError('Renseignez votre adresse email.'); return; }
    if (email.length > 254 || !EMAIL_RE.test(email)) {
      showError('Cette adresse email semble incomplète. Vérifiez le format (nom@domaine.fr).');
      return;
    }

    clearError();
    form.dataset.submitting = '1';
    button.disabled = true;

    // Message de succès propre à chaque formulaire (alerte salons vs newsletter).
    const successMsg = form.dataset.successMsg || 'Merci, c\'est noté.';
    // Stub : remplacer par l'appel réseau réel. En cas d'échec, appeler
    // showError('…') et restaurer button.disabled = false / submitting = '0'.
    form.innerHTML =
      '<p class="form-success">' +
      '<span class="form-success__check" aria-hidden="true">✓</span> ' +
      escapeHtml(successMsg) +
      '</p>';
  });
}

function bindReveal() {
  const els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || els.length === 0) {
    els.forEach(el => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(el => io.observe(el));
}

/* ===========================================================================
 * BOOT
 * =========================================================================== */

/* Clé visuelle pin ↔ ligne : au survol d'un pin, sa ligne agenda s'éclaire (et
   l'inverse). Le lien reste lisible pendant l'interaction, pas seulement via le
   flash post-clic. Souris uniquement (la carte est décorative / aria-hidden). */
function bindPinRowLink() {
  document.querySelectorAll('.france-pin-link[data-scroll-to]').forEach(pin => {
    const row = document.getElementById(pin.getAttribute('data-scroll-to'));
    if (!row) return;
    const on  = () => { row.classList.add('is-pin-linked'); pin.classList.add('is-row-linked'); };
    const off = () => { row.classList.remove('is-pin-linked'); pin.classList.remove('is-row-linked'); };
    pin.addEventListener('mouseenter', on);
    pin.addEventListener('mouseleave', off);
    row.addEventListener('mouseenter', on);
    row.addEventListener('mouseleave', off);
  });
}

function bindPinScroll() {
  document.querySelectorAll('.france-pin-link[data-scroll-to]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const id = link.getAttribute('data-scroll-to');
      const target = document.getElementById(id);
      if (!target) return;
      const rect = target.getBoundingClientRect();
      const targetY = window.scrollY + rect.top - (window.innerHeight / 2) + (rect.height / 2);
      window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
      // Flash highlight
      target.classList.remove('is-pin-targeted');
      // Force reflow so the class re-triggers the animation
      void target.offsetWidth;
      target.classList.add('is-pin-targeted');
      window.setTimeout(() => target.classList.remove('is-pin-targeted'), 2200);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const upcoming = getUpcomingSalons();

  injectFrancePath();
  injectBelgiumPath();
  renderMapPins(upcoming);
  renderAgenda(upcoming);
  renderJsonLd(upcoming);

  bindIcsButtons();
  bindItineraireToast();
  bindEmailForms();
  bindReveal();
  bindPinScroll();
  bindPinRowLink();
});
